import { render, staticRenderFns } from "./RequestPendingWelcome.vue?vue&type=template&id=1fd64c3e"
import script from "./RequestPendingWelcome.vue?vue&type=script&lang=js"
export * from "./RequestPendingWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports